module.exports = __webpack_public_path__ + "static/media/f6.061c5851.png";